import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasetEntities, getTabs } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: get(state, "global.selected.account"),
    datasetId: get(props, "params.datasetId"),
  }),
  required: ["account", "datasetId"],
  data: [{
    resource: "datasetEntitlements",
    url: ({ account, datasetId }) => `/api/${account}/reports/entitlements/dataset/${datasetId}`,
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state),
    userId: get(state, "user.id"),
    dataset: get(props, "dataset.data.dataset"),
    datasetEntities: getDatasetEntities(state, props),
    members: get(props, "dataset.data.dataset.members"),
    teams: get(props, "dataset.data.dataset.teams"),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
